import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [state, setState] = useState(location.state?.user ? "ok" : "checking");

  useEffect(() => {
    if (location.state?.user) return;
    fetch(`${API}/auth/me`, { credentials: "include" })
      .then((r) => {
        if (!r.ok) throw new Error("unauth");
        return r.json();
      })
      .then((user) => {
        if (!user.is_admin) {
          setState("denied");
        } else {
          setState("ok");
        }
      })
      .catch(() => {
        setState("no");
        navigate("/login");
      });
  }, [location.state, navigate]);

  if (state === "checking") {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="w-10 h-10 border-2 border-white/20 border-t-[var(--primary)] rounded-full animate-spin" />
      </div>
    );
  }

  if (state === "denied") {
    return (
      <div className="min-h-screen bg-[#050505] flex flex-col items-center justify-center gap-6 px-6 text-center">
        <h1 className="font-display font-bold text-4xl">Accès refusé</h1>
        <p className="text-white/55 max-w-md">Ce compte n'est pas autorisé à accéder à l'administration.</p>
        <button onClick={() => navigate("/login")} data-testid="denied-back" className="px-6 py-3 rounded-full border border-white/20 hover:border-[var(--primary)] font-mono-p text-sm transition-colors">
          Changer de compte
        </button>
      </div>
    );
  }

  if (state === "ok") return children;
  return null;
}
